import { useRouter } from "next/router";
import Head from "next/head";

import { request } from "graphql-request"

import { Header } from "../components/Header";
import Layout from "../components/layout";
import styles from '../styles/allies.module.scss'
import Form from 'react-bootstrap/Form';
import Image from 'next/image'
import {
  GET_MENU_YACHTS,
  GET_FOOTER,
  GET_LATEST_YACHTS
} from "../lib/queries";
import { useEffect } from "react";
import { useState } from "react";


export async function getServerSideProps(context) {
  try{
    const { locale } = context;

    const { yachts } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_MENU_YACHTS,
      { locale: locale },
    )
    const { footer } = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_FOOTER,
      { locale: locale },
    )
    const { yachts: latestYachts} = await request(
      process.env.STRAPI_GRAPHQL_ENDPOINT,
      GET_LATEST_YACHTS,
      { locale: locale },
    )
  
    const response = await fetch('https://yachting-mexico.herokuapp.com/allie');
    const allies = await response.json();
    
  
    if ( !footer || !latestYachts || !allies ) {
      return {
        notFound: true,
      };
    }
  
    return {
      props: {
        data: allies,
        navbar: yachts,
        footer,
        latestYachts
      },
    };
  }catch(e){
    return {
      notFound: true,
    };
  }
  
}

const Allies = ({ data, navbar, footer, latestYachts }) => {
  const router = useRouter();
  const alliesList = data.allie
  const background = data.background[0].url
  const title = data.title


  const [states, setStates] = useState([]);
  const [allies, setAllies] = useState([])

  const handleSelect = (value)=>{
    const filter = alliesList.filter(allie => allie.state === value)
    setAllies(filter);
  }

  useEffect(()=>{
    const states =  [...new Set(alliesList.map(item => item.state))];
    setStates(states);
    setAllies(alliesList);
  },[])
  return (
    <Layout header={navbar} footer={footer} latestYachts={latestYachts}>
      <Head>
        <title>Yachting México | {router.locale === "es" ? "Aliados" : "Allies"}</title>
      </Head>

      <Header
        title="Allies"
        imgSrc="/header.webp"
        imgAlt="Yachts sailing on lake with emerald-like water"
        rootLabel={router.locale === "es" ? "Inicio" : "Home" }
      />

      <section className={styles.allies} style={background ? {backgroundImage: 'url('+background+')'}:{ backgroundImage:'none'}}>
        <div className={styles.alliesHeader}>
          <h3>{title}</h3>
          <Form.Select aria-label="State select" onChange={(event)=>handleSelect(event.target.value)}>
            <option disabled selected> {router.locale === "es" ? "Elige un estado" : "Choose a state"}</option>
            {
              states.map((item,idx)=>{
                return(
                  <option value={item}>{item}</option>
                )
              })
            }

          </Form.Select>
        </div>
        <div className={styles.alliesWrapper}>
        {allies.length == 0 ?
            <h4 className="text-center">
              {router.locale === "es" ?
                "No se encontraron aliados" :
                "No allies found"}
            </h4>
              :
            allies.map((allie, index)=>{
              return(
              <div className={styles.alliesItem}>
                <div className={styles.allieLogo}>
                  <Image
                    src={allie.logo.url}
                    alt={allie.name}
                    layout="fill"
                    loading='lazy'
                    objectFit="contain"
                  />
                </div>
                
                <span>{allie.name}</span>
                
                <a className="btn btn-primary" href={allie.web}> {router.locale === "es" ? "Visitar pagina web" : "Visit webpage"}</a>
                
                <a className={styles.alliePhone} href={`tel:${allie.phone}`} target="_blank">
                  <span> {router.locale === "es" ? "Teléfono" : "Phone"}</span>
                  {allie.phone}
                </a>
                
                <a className={styles.allieLocation} href={allie.location} target="_blank">
                  <span> {router.locale === "es" ? "Ubicación" : "Location"}</span>
                  {allie.address}
                </a>
                {
                  allie.map ?
                  <iframe src={allie.map} width="100%" height="150" allowfullscreen="false" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                  :
                  null
                }

              </div>

              )
              
            })
          }
        </div>

      </section>
    </Layout>
  );
};

export default Allies;
